import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  private pendingRequests = 0;

  constructor() {}

  start() {
    this.pendingRequests++;
    this.isLoading.emit(true);
  }

  finish() {
    this.pendingRequests--;
    if (this.pendingRequests === 0) {
      this.isLoading.emit(false);
    }
  }

  reset() {
    this.pendingRequests = 0;
    this.isLoading.emit(false);
  }
}
